import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "weltascorp_neon_cookie_consent";

export const COOKIE_CATEGORIES = {
  necessary: {
    id: "necessary",
    label: "Necesarias",
    description: "Imprescindibles para la navegación, seguridad, carta digital, pedidos de mesa y gestión de preferencias.",
  },
  analytics: {
    id: "analytics",
    label: "Analíticas",
    description: "Nos ayudan a medir el uso de la web y mejorar carta, reservas, eventos y experiencia de usuario.",
  },
  marketing: {
    id: "marketing",
    label: "Marketing",
    description: "Permiten medir campañas, promociones y contenidos publícitarios de NEON solo si las activamos y das tu consentimiento.",
  },
};

function getDefaultConsent() {
  return {
    necessary: true,
    analytics: false,
    marketing: false,
    timestamp: null,
  };
}

function loadConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (_) {}
  return null;
}

function saveConsent(consent) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
}

export function useCookies() {
  const [consent, setConsentState] = useState(() => loadConsent() || getDefaultConsent());
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const saved = loadConsent();
    if (!saved || !saved.timestamp) {
      setShowBanner(true);
    }
  }, []);

  useEffect(() => {
    const handler = () => {
      setShowSettings(true);
      setShowBanner(true);
    };
    window.addEventListener("weltascorp:open-cookies", handler);
    return () => window.removeEventListener("weltascorp:open-cookies", handler);
  }, []);

  const acceptAll = useCallback(() => {
    const updated = { necessary: true, analytics: true, marketing: true, timestamp: Date.now() };
    setConsentState(updated);
    saveConsent(updated);
    setShowBanner(false);
    setShowSettings(false);
  }, []);

  const rejectAll = useCallback(() => {
    const updated = { necessary: true, analytics: false, marketing: false, timestamp: Date.now() };
    setConsentState(updated);
    saveConsent(updated);
    setShowBanner(false);
    setShowSettings(false);
  }, []);

  const saveCustom = useCallback((prefs) => {
    const updated = { ...prefs, necessary: true, timestamp: Date.now() };
    setConsentState(updated);
    saveConsent(updated);
    setShowBanner(false);
    setShowSettings(false);
  }, []);

  const openSettings = useCallback(() => setShowSettings(true), []);
  const closeSettings = useCallback(() => setShowSettings(false), []);

  return {
    consent,
    showBanner,
    showSettings,
    acceptAll,
    rejectAll,
    saveCustom,
    openSettings,
    closeSettings,
  };
}
